import Holding from '@/components/Pages/BuildYourDreamBag/Holding'
import { CAMPAIGNS } from '@/constants/campaigns'
import closedLayout from '@/constants/contents/greatest_hits/layout/closed.json'
import { DEFAULT_LOCALE } from '@/constants/locales'
import {
  getBydbCampaignDateOverrides,
  getBydbMarketLocale,
} from '@/utils/bydb-market'
import { getBydbPublicPath } from '@/utils/bydb-routes'
import checkCampaign from '@/utils/check-campaign'
import { getIsSsrMobile } from '@/utils/get-is-ssr-mobile'

export default Holding

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const locale = getBydbMarketLocale(ctx) ?? ctx.params?.locale ?? DEFAULT_LOCALE
  const isOpen = await checkCampaign(
    CAMPAIGNS.BYDB.name,
    getBydbCampaignDateOverrides(locale),
    locale,
  )
  const query = ctx.resolvedUrl.split('?')[1]

  if (isOpen) {
    return {
      redirect: {
        destination: `${getBydbPublicPath(locale)}${query ? `?${query}` : ''}`,
        permanent: false,
      },
    }
  }

  return {
    props: {
      locale,
      layout: closedLayout[locale as keyof typeof closedLayout] ?? null,
      isSsrMobile: getIsSsrMobile(ctx),
    },
  }
}
